module.exports = __webpack_public_path__ + "img/okumidori-h.ed9cce55.jpg";